import {
  CheckSquare,
  SkipForward,
  Square,
  XCircle,
} from "lucide-react";
import * as React from "react";

interface Task {
  task_num: number;
  title: string;
  description: string;
  status: string;
}

interface TasksRendererProps {
  tasks: Task[];
}

export const TasksRenderer = React.memo<TasksRendererProps>(function TasksRenderer({ tasks }) {
  return (
    <div className="space-y-2 mt-1 pl-2 border border-border p-2 rounded-md">
      {tasks.map((task, index) => {
        const getTaskStyling = () => {
          switch (task.status) {
            case "COMPLETED":
              return {
                icon: <CheckSquare className="h-4 w-4 text-green-500" />,
                textClass: "text-green-500 line-through",
              };
            case "PENDING":
              return {
                icon: <Square className="h-4 w-4 text-muted-foreground" />,
                textClass: "text-foreground",
              };
            case "IN_PROGRESS":
              return {
                icon: <Square className="h-4 w-4 text-primary" />,
                textClass: "text-primary",
              };
            case "SKIPPED":
              return {
                icon: <SkipForward className="h-4 w-4 text-muted-foreground" />,
                textClass: "text-muted-foreground line-through",
              };
            case "FAILED":
              return {
                icon: <XCircle className="h-4 w-4 text-red-400" />,
                textClass: "text-red-400 line-through",
              };
            default:
              return {
                icon: <Square className="h-4 w-4 text-muted-foreground" />,
                textClass: "text-foreground",
              };
          }
        };

        const { icon, textClass } = getTaskStyling();

        return (
          <div key={index} className="flex items-center gap-2">
            {icon}
            <span className={textClass}>
              {task.task_num}: {task.title}
            </span>
          </div>
        );
      })}
    </div>
  );
});